export default "./cf98eff2b5c379e4224604e79c4544eb.svg";